var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivitiesEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "265px",
    height: "261px",
    viewBox: "0 0 265 261",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9649EFD6-5EDD-497C-981A-823C18095F60") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Student-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Student-Profile-default",
    transform: "translate(-587.000000, -2020.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bkgd",
    transform: "translate(0.000000, 11.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bkgd",
    x: 0,
    y: 0,
    width: 1440,
    height: 5510
  })), /*#__PURE__*/React.createElement("g", {
    id: "Activities",
    transform: "translate(208.000000, 1836.000000)",
    fill: "#E6E5E5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516,225 L644,225 L644,184 L516,184 L516,225 Z M379,288 L481,288 L481,186 L379,186 L379,288 Z M516,286 L644,286 L644,245 L516,245 L516,286 Z M516,384 L644,384 L644,343 L516,343 L516,384 Z M379,444 L481,444 L481,342 L379,342 L379,444 Z M516,445 L644,445 L644,404 L516,404 L516,445 Z",
    id: "Activities-Icon"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesEmpty);
export default __webpack_public_path__ + "static/media/activities-empty.66115fad794716230aff3bf429ba574f.svg";
export { ForwardRef as ReactComponent };